export default __webpack_public_path__ + "static/h06-bd20473c5be1d6f73c0eb07222afdbd3.png";